export default __webpack_public_path__ + "static/media/3-1-1.4e1dce0f.jpg";